import { useCallback } from "react";
import stringify from "fast-json-stable-stringify";

import { duration } from "@formant/core/model/duration";
import { IEventCounts } from "@formant/core/model/IEventCounts";
import { IEventFilter } from "@formant/core/model/IEventFilter";

import { useTimer } from "../component/common/Timer";
import { eventStore } from "../stores";

const shortRefreshInterval = 10 * duration.second;
const longRefreshInterval = 60 * duration.second;

function calculateUpdateInterval(filter: IEventFilter): number {
    // if the filter has tags, use the long refresh interval
    // to alleviate request/server pressure.
    if (Object.keys(filter.tags ?? {}).length > 0) {
        return longRefreshInterval;
    }

    // if the filter has names, use the long refresh interval
    // to alleviate request/server pressure.
    if ((filter.names ?? []).length > 0) {
        return longRefreshInterval;
    }

    return shortRefreshInterval;
}

export function useLiveEventCounts(
    eventFilter: IEventFilter,
): IEventCounts | undefined {
    const updateCount = useCallback(async () => {
        await eventStore.refreshCounts(eventFilter);
    }, [stringify(eventFilter)]);

    useTimer(updateCount, {
        interval: calculateUpdateInterval(eventFilter),
        wait: true,
    });

    return eventStore.counts(eventFilter);
}
